module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/cm-vid-poster-76f8f4aa5e66b1bfdd8b848349b68072.jpg";